/**
 * Gujarati for the two core namespaces (BP-19.T2).
 *
 * **Machine draft, not reviewed** — see `hi.ts` for why `settings` is absent and what
 * the `{{…}}` placeholders are for.
 */

export const guCommon = {
  app: {
    staff: '26AD સ્ટાફ',
    client: '26AD',
  },
  nav: {
    label: 'સેટિંગ્સ',
    tenant: 'સલૂન',
    users: 'વપરાશકર્તાઓ',
    security: 'સુરક્ષા',
    logout: 'લૉગ આઉટ',
    signIn: 'સાઇન ઇન',
    more: 'વધુ',
    group: {
      frontDesk: 'ફ્રન્ટ ડેસ્ક',
      salon: 'સલૂન',
      business: 'વ્યવસાય',
    },
    item: {
      home: 'હોમ',
      calendar: 'કૅલેન્ડર',
      myDay: 'મારો દિવસ',
      sales: 'વેચાણ',
      clients: 'ગ્રાહકો',
      dayClose: 'દિવસ બંધ',
      catalogue: 'કૅટલૉગ',
      services: 'સેવાઓ',
      stock: 'સ્ટૉક',
      team: 'ટીમ',
      marketing: 'માર્કેટિંગ',
      reports: 'અહેવાલ',
      money: 'નાણાં',
      settings: 'સેટિંગ્સ',
      printQueue: 'પ્રિન્ટ કતાર',
      myCommission: 'મારું કમિશન',
      commissions: 'કમિશન',
      myShifts: 'મારી શિફ્ટ',
      accounting: 'હિસાબ',
    },
  },
  action: {
    save: 'સાચવો',
    saving: 'સાચવી રહ્યા છીએ…',
    cancel: 'રદ કરો',
    retry: 'ફરી પ્રયાસ કરો',
  },
  state: {
    loading: 'લોડ થઈ રહ્યું છે…',
    empty: 'અહીં હજી કશું નથી.',
    error: 'કંઈક ખોટું થયું.',
  },
  banner: {
    readonly:
      'આ વર્કસ્પેસ ફક્ત વાંચવા માટે છે. તમે બધું જોઈ શકો છો; ફરી શરૂ થાય ત્યાં સુધી ફેરફારો સ્વીકારાશે નહીં.',
    offline: 'તમે ઑફલાઇન છો. આ ઉપકરણ પર સાચવેલો છેલ્લો ડેટા બતાવીએ છીએ.',
  },
  route: {
    notFound: 'પેજ મળ્યું નથી',
    forbidden: 'આ પેજ માટે તમને પરવાનગી નથી.',
  },
  locale: {
    label: 'ભાષા',
    switch: 'ભાષા બદલો',
    draft: 'હિન્દી, મરાઠી અને ગુજરાતી મશીનથી બનેલા મુસદ્દા છે; સલૂને તે હજી તપાસ્યા નથી.',
  },
  hello: {
    title: '26AD નમસ્તે',
    loading: '26AD api સાથે સંપર્ક કરી રહ્યા છીએ…',
    error: '26AD api સુધી પહોંચી શકાયું નહીં.',
  },
} as const;

export const guAuth = {
  login: {
    title: 'સાઇન ઇન',
    email: 'ઇમેઇલ',
    password: 'પાસવર્ડ',
    submit: 'સાઇન ઇન કરો',
    submitting: 'સાઇન ઇન થઈ રહ્યું છે…',
    redirecting: 'તમને સાઇન ઇન પેજ પર લઈ જઈ રહ્યા છીએ…',
  },
  totp: {
    title: 'દ્વિ-પગલાં ચકાસણી',
    hint: 'તમારું ખાતું ઑથેન્ટિકેટર ઍપથી સુરક્ષિત છે. હમણાં દેખાતો છ અંકનો કોડ દાખલ કરો.',
    code: 'એક-વખતનો કોડ',
    submit: 'ચકાસો',
  },
  otp: {
    title: 'સાઇન ઇન',
    phone: 'મોબાઇલ નંબર',
    phoneHint: 'આંતરરાષ્ટ્રીય સ્વરૂપમાં, દા.ત. +919820000000',
    send: 'કોડ મોકલો',
    sending: 'મોકલી રહ્યા છીએ…',
    sent: 'અમે {{phone}} પર કોડ મોકલ્યો છે.',
    code: 'છ અંકનો કોડ',
    verify: 'ચકાસો',
    verifying: 'ચકાસી રહ્યા છીએ…',
    devCode: 'ડેવલપમેન્ટ કોડ: {{code}}',
    signedIn: '{{phone}} તરીકે સાઇન ઇન',
    role: 'ભૂમિકા: ગ્રાહક',
  },
  error: {
    invalid: 'આ ઇમેઇલ, પાસવર્ડ કે એક-વખતનો કોડ સાચો નથી.',
    locked: 'ઘણી વાર પ્રયાસ થયો. એક મિનિટ થોભીને ફરી પ્રયાસ કરો.',
    readonly: 'આ વર્કસ્પેસ ફક્ત વાંચવા માટે છે, તેથી અત્યારે સાઇન ઇનથી સત્ર શરૂ થઈ શકતું નથી.',
    unknown: 'સાઇન ઇન થઈ શક્યું નહીં. ફરી પ્રયાસ કરો.',
    phone: 'મોબાઇલ નંબર આંતરરાષ્ટ્રીય સ્વરૂપમાં દાખલ કરો, દા.ત. +919820000000.',
    otp: 'આ કોડ સાચો નથી.',
  },
} as const;

/** The namespaces Gujarati carries. */
export const gu = { common: guCommon, auth: guAuth } as const;
